import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../../form.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { HttpError } from '../../../errors';
import { catchError } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operator/takeUntil';

@Component({
  selector: 'app-student-signing',
  templateUrl: './student-signing.component.html',
  styleUrls: ['./student-signing.component.scss']
})
export class StudentSigningComponent implements OnInit, OnDestroy {
  @ViewChild(SignaturePad) signaturePad;
  public signature = null;

  private formCode;
  private studentId;

  public administrationFormData;
  public signatureFormData;

  private destroy$ = new Subject<boolean>();

  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 1,
    'canvasWidth': 840,
    'canvasHeight': 120,
    'label': 'Handtekening'
  };

  constructor(private route: ActivatedRoute, private router: Router,
    private formService: FormService, private snackbar: SemsoSnackbarService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.formCode = params['formCode'];
      this.studentId = params['studentId'];

      this.administrationFormData = this.formService.getStudentAdministrationData(this.formCode)
        .takeUntil(this.destroy$)
        .map(data => {
          this.loadSignature();
          return data;
        })
        .pipe(catchError(e => {
          throw this.error(`Fout bij het ophalen van administratieinformatie voor formulier: ${this.formCode}`);
        }));
    });
  }

  private loadSignature() {
    this.formService.getStudentSignatureData(this.formCode, 'Student')
      .takeUntil(this.destroy$)
      .subscribe(data => {
        const date = new Date();
        if (!data.datum) {
          data.datum = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
        } 
        if (data.handtekening) {
          this.signaturePad.fromDataURL(data.handtekening);
          this.signature = data.handtekening;
        }
        this.signatureFormData = data;
      }, e => {
        throw this.error(`Fout bij het ophalen van de handtekening voor formulier: ${this.formCode}`);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  drawComplete() {
    this.signature = this.signaturePad.toDataURL();
  }

  resetSignature() {
    this.signaturePad.clear();
    this.signature = '';
  }

  sign() {
    this.formService.postStudentSignatureData(this.formCode, {
      naam: this.signatureFormData.naam,
      datum: this.signatureFormData.datum,
      functie: this.signatureFormData.functie,
      examencommissie_Akkoord: false,
      handtekening: this.signature,
      type: 'Student'
    }).takeUntil(this.destroy$)
      .subscribe(() => {
        this.router.navigate(['../examination-committee'], { relativeTo: this.route, queryParamsHandling: 'merge' });
      }, e => {
        throw this.error(`Fout bij het opslaan van de gegevens voor formulier: ${this.formCode}`);
      });
  }

  signatureIsEmpty() {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty();
    }
    return true;
  }

  private error(message) {
    this.snackbar.error(message);
    return new HttpError(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/student-signing/student-signing.component.ts